import type { ROUTE_DICT } from 'lumen/utils/constants/route-constants';

export const TRIAL_INDICATION_LOCALSTORAGE_NEARLY_EXPIRED_AUTO_OPEN =
  'app-trial-indication-contact-request-has-pushed-nearly-expired';

export const TRIAL_INDICATION_LOCALSTORAGE_KEY =
  'app-trial-indication-contact-request-sent-subscriptions';

export const TRIAL_INDICATION_LOCALSTORAGE =
  'app-trial-indication-contact-request';

export const TRIAL_INDICATION_LOCALSTORAGE_EXPIRED_AUTO_OPEN =
  'app-trial-indication-contact-request-has-pushed-expired';

export type TrialIndicationRoute = keyof typeof ROUTE_DICT;
